import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledInput = styled.input`
  &&& {
    -webkit-appearance: none;

    width: 100%;
    height: 45px;
    padding: 10px 12px;
    outline: none;

    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements.form?.elements?.inputField?.elements
          ?.input,
      )}

    &::placeholder {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.form?.elements?.inputField?.elements
            ?.input?.elements?.placeholder,
        )}
    }

    &:focus {
      ${({ theme }) =>
        renderStyledElementStyles(
          theme,
          theme.module.vStyles.elements.form?.elements?.inputField?.elements
            ?.input?.elements?.focus,
        )}
    }

    ${({ theme, hasError }) =>
      hasError
        ? renderStyledElementStyles(
            theme,
            theme.module.vStyles.elements.form?.elements?.inputField?.elements
              ?.inputError,
          )
        : null}

    &:focus {
      ${({ theme, hasError }) =>
        hasError
          ? renderStyledElementStyles(
              theme,
              theme.module.vStyles.elements.form?.elements?.inputField?.elements
                ?.inputError?.elements?.focus,
            )
          : null}
    }
  }
`;
